import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsPY: CultureInfo = {
  name: 'es-PY',
  displayName: 'Spanish (Paraguay)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-PY',
  parent: CultureInfoEs
};
